module.exports = __webpack_public_path__ + "img/amerta.d1ec5876.jpg";